import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_14'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_14',
  name: "Which of the following topics are included within the facility's written policies and procedures for raw materials sourcing?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CUSTOMER_AND_OR_LEGAL_REQUIREMENTS_FOR_RAW_MATERIALS_IDENTIFICA',
      text: 'Customer and/or legal requirements for raw materials identification, reporting and/or due diligence',
      externalIds: [
        {
          id: 'ms-pla-51x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RAW_MATERIAL_SUPPLY_CHAIN_POLICY_APPLICABLE_TO_SUPPLIERS_SUBCON',
      text: "Raw material supply chain policy applicable to suppliers/subcontractors through facility's sourcing agreements with its suppliers/subcontractors ",
      externalIds: [
        {
          id: 'ms-pla-52x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RISK_ASSESSMENT_TO_DIFFERENTIATE_HIGH_RISK_MATERIALS_WITHIN_THE',
      text: 'Risk assessment to differentiate high risk materials within the supply chain',
      externalIds: [
        {
          id: 'ms-pla-53x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-pla-54x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-pla-55f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CUSTOMER_AND_OR_LEGAL_REQUIREMENTS_FOR_RAW_MATERIALS_IDENTIFICA',
                'RAW_MATERIAL_SUPPLY_CHAIN_POLICY_APPLICABLE_TO_SUPPLIERS_SUBCON',
                'RISK_ASSESSMENT_TO_DIFFERENTIATE_HIGH_RISK_MATERIALS_WITHIN_THE',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-50',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20480,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
